"use client";

import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { captureAttributionCode } from "~/lib/attribution";
import { captureLandingUtm } from "~/lib/utm";

export function AttributionCapture() {
  const searchParams = useSearchParams();

  useEffect(() => {
    // Campaign params are read on every navigation, not just the first: a
    // visitor can arrive on any route from an ad. captureLandingUtm ignores a
    // navigation that carries none, so in-site clicks don't clear the landing
    // value.
    captureLandingUtm(searchParams);

    let code = searchParams.get("attribution_code");

    if (!code) {
      const next = searchParams.get("next");
      if (next) {
        try {
          const nextUrl = new URL(next, window.location.origin);
          code = nextUrl.searchParams.get("attribution_code");
        } catch {
          // malformed next param — ignore
        }
      }
    }

    if (code) {
      captureAttributionCode(code);
    }
  }, [searchParams]);

  return null;
}
